import Search from './Search.vue';

const routes = [
  {
    path: '/search/:searchQuery?',
    name: 'Search',
    component: Search
  }
];

export default routes;
